import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Calendar, Monitor, Smartphone, Settings as SettingsIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { useAuthStore, selectIsAdmin } from '../../stores/auth.store';
export default function SettingsPage() {
    const isAdmin = useAuthStore(selectIsAdmin);
    const settings = [
        {
            title: 'Pay Periods',
            description: 'Configure pay period schedules and settings',
            href: '/settings/pay-periods',
            icon: Calendar,
            adminOnly: true,
        },
        {
            title: 'Time Clock Devices',
            description: 'Manage kiosk devices and pairing codes',
            href: '/settings/time-clock-devices',
            icon: Monitor,
            adminOnly: true,
        },
        {
            title: 'Mobile Clock In/Out',
            description: 'Allow or block staff from clocking in/out on their phones',
            href: '/settings/mobile-punch',
            icon: Smartphone,
            adminOnly: true,
        },
    ];
    const availableSettings = settings.filter((setting) => !setting.adminOnly || isAdmin);
    return (_jsxs("div", { className: "p-6 max-w-4xl mx-auto space-y-6", children: [_jsxs("div", { children: [_jsxs("div", { className: "flex items-center gap-3 mb-2", children: [_jsx(SettingsIcon, { className: "w-8 h-8 text-gray-600" }), _jsx("h1", { className: "text-3xl font-bold", children: "Settings" })] }), _jsx("p", { className: "text-muted-foreground", children: "Manage system configuration and preferences" })] }), _jsx("div", { className: "grid gap-4 md:grid-cols-2", children: availableSettings.map((setting) => (_jsx(Link, { to: setting.href, children: _jsx(Card, { className: "p-6 hover:shadow-md transition-shadow cursor-pointer h-full", children: _jsxs("div", { className: "flex items-start gap-4", children: [_jsx("div", { className: "p-3 bg-brand-50 rounded-lg", children: _jsx(setting.icon, { className: "w-6 h-6 text-brand-600" }) }), _jsxs("div", { children: [_jsx("h3", { className: "font-semibold text-lg mb-1", children: setting.title }), _jsx("p", { className: "text-sm text-muted-foreground", children: setting.description }), setting.adminOnly && (_jsx("span", { className: "inline-block mt-2 px-2 py-0.5 bg-purple-100 text-purple-700 text-xs rounded", children: "Admin Only" }))] })] }) }) }, setting.href))) }), !isAdmin && (_jsx(Card, { className: "p-4 bg-gray-50", children: _jsx("p", { className: "text-sm text-gray-600", children: "Additional settings are available to administrators." }) }))] }));
}
